<template>
    <div>
        <div class="d-flex justify-content-between">
            <h1 class="page-header">{{ $t('purchaseRequestTemplate.create') }}</h1>
            <ts-breadcrumb :items="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('purchaseRequestTemplate.pageTitle'),
                    href: '/admin/purchase-request-templates'
                },
                {
                    text: $t('create'),
                    active: true
                }
            ]" />
        </div>
        <ts-card>
            <ts-card-wrapper>
                <ts-loading-banner :loading="loading">
                    <form class="form-horizontal ts-space-y-3">
                        <div class="row">
                            <div class="col-md-12">
                                <Info v-model="model" :validate="errors" class="tw-p-3 tw-rounded" />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="d-flex justify-content-between align-items-center ts-mb-2">
                                    <h5 class="ts-font-bold ts-mb-0">{{ $t('purchaseRequestTemplate.items') }}</h5>
                                    <button type="button" class="btn btn-success" @click="$refs.productList.show()">
                                        <i class="fa fa-plus ts-mr-1"></i> {{ $t('purchaseRequestTemplate.addItems') }}
                                    </button>
                                </div>
                                <ItemList v-model="model" :validate="errors" class="ts-border ts-rounded" />
                                <ProductList ref="productList" v-model="model" />
                            </div>
                        </div>
                        <div class="row ts-mt-4">
                            <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
                                <ts-button @click.prevent="$router.push({ name: 'purchase-request-template' })">{{
                                    $t('cancel') }}</ts-button>
                                <ts-button :waiting="loading" @click.prevent="onSave" color="primary">{{ $t('save')
                                    }}</ts-button>
                            </div>
                        </div>
                    </form>
                </ts-loading-banner>
            </ts-card-wrapper>
        </ts-card>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import Info from './components/info.vue'
import ItemList from './components/item-list'
import ProductList from './components/product-list'

export default {
    name: 'templateCreate',
    components: {
        Info,
        ItemList,
        ProductList
    },
    data() {
        return {
            loading: false,
            errors: new Errors(),
            model: {
                template_name: '',
                template_description: '',
                details: []
            }
        }
    },
    methods: {
        ...mapActions('purchaseRequest/template', ['getFormViewModel', 'store']),
        async getPreData({ params, index }) {
            this.loading = true
            await this.getFormViewModel({ index: index, params: params })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => (this.loading = false))
        },
        onSave() {
            if (!this.model.template_name) {
                this.$toasted.error(this.$t('purchaseRequestTemplate.pleaseEnterName'))
                return
            }
            if (this.model.details.length === 0) {
                this.$toasted.error(this.$t('purchaseRequestTemplate.pleaseAddItems'))
                return
            }

            this.loading = true
            this.errors = new Errors()
            this.store(this.model)
                .then(response => {
                    this.$toasted.success(response.message)
                    this.$router.push({ name: 'purchase-request-template' })
                })
                .catch(error => {
                    this.errors = new Errors(error.errors)
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    },
    created() {
        this.getPreData({
            params: {},
            index: 'products,unitOfMeasures,productCategories,productGroups'
        })
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('purchaseRequest/template/CLEAR_SETUP')
        next()
    }
}
</script>
